module.exports = __webpack_public_path__ + "static/media/appetizer-long.a6c4e4f9.svg";